import React, { useMemo } from "react";
import { MultiSelect } from "./Select/MultiSelect";

type Option = {
  label: string | React.ReactElement;
  value: string | number;
};

interface IBaseText {
  id: number;
  name: string;
}

type PTextMultiSelect<T extends IBaseText> = {
  listOfValues: T[];
  selectedValues: (string | number)[];
  onChange: (values: (string | number)[]) => void;
  label: string;
  color: string;
  baseColor: string;
  borderColor: string;
  expandedBorderColor?: string;
  currentId?: number;
  enableSearch?: boolean;
};

export const TextMultiSelect = <T extends IBaseText>(
  props: PTextMultiSelect<T>
) => {
  const {
    listOfValues,
    selectedValues,
    onChange,
    label,
    color,
    baseColor,
    borderColor,
    expandedBorderColor,
    currentId,
    enableSearch = false,
  } = props;

  const options: Option[] = useMemo(() => {
    return listOfValues.map((item) => ({
      label: (
        <div className="flex flex-row justify-between w-full">
          <div className="flex items-center gap-[10px]">
            <span className="text-text-base font-normal text-[12px]">
              {item.name}
            </span>
          </div>
        </div>
      ),
      value: item.id,
    }));
  }, [listOfValues]);

  return (
    <MultiSelect
      options={options}
      selectedValues={selectedValues}
      onChange={onChange}
      label={label}
      enableSearch={enableSearch}
      color={color}
      baseColor={baseColor}
      borderColor={borderColor}
      expandedBorderColor={expandedBorderColor}
      searchableLabels={listOfValues.map((merchant) => merchant.name)}
    />
  );
};
